const registry = {};

export const isOdd = number => number % 2 === 0;
registry.isOdd = isOdd;

export default registry;